var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('section-header',{class:_vm.$style.header,on:{"signup":function($event){return _vm.signup()}}}),_c('section-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }